import React, { useEffect } from 'react';
import { paymentAction } from 'redux/modules';
import { useDispatch } from 'react-redux';
import { Result, Button } from 'antd';
import { Helmet } from 'react-helmet';

const Error = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(paymentAction.clearLocalStorage());
  }, []);

  return (
    <>
      <Helmet>
        <title>Hata – Bir Sorun Oluştu | Depopro</title>
        <meta
          name="description"
          content="İşleminiz sırasında bir hata oluştu. Lütfen tekrar deneyin veya destek ile iletişime geçin."
        />
      </Helmet>
      <section style={{ width: '100%', height: '100%', display: 'table', textAlign: 'center' }}>
        <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          <Result
            status="error"
            icon={<img alt="error-icon" src={'img/error.svg'} />}
            title={
              <div style={{ color: '#ED1C24', fontSize: 26, fontWeight: 'bold' }}>
                Ödeme İşleminiz Başarısız Oldu
              </div>
            }
            subTitle={
              <div>Şu An İşleminizi Gerçekleştiremiyoruz, Lütfen Daha Sonra Tekrar Deneyiniz.</div>
            }
            extra={
              <Button
                style={{ backgroundColor: '#f27a1a', color: '#fff', border: 'none' }}
                href={'http://www.depopro.com.tr'}
                type="primary"
              >
                Ana Sayfa
              </Button>
            }
          />
        </div>
      </section>
    </>
  );
};

export default Error;
